  <div class="py-2 w-full">
    <label [for]="id" class="block font-medium text-gray-700 dark:text-gray-200 font-auth mb-1">
      {{ label }}
    </label>

    @if (type === 'password') {
      <p-password
        [feedback]="false"
        [toggleMask]="true"
        [placeholder]="placeholder"
        [inputId]="id"
        [ngModel]="value"
        [disabled]="disabled"
        (ngModelChange)="onChange($event)"
        (onBlur)="onTouched()"
        styleClass="!w-full"
        inputStyleClass="!w-full !border !border-[#D4D4D8] !rounded-xl !px-3 !py-2  !text-sm !placeholder-gray-400 dark:placeholder-white !transition-all !duration-200 !dark:bg-[#52525B] "
      />
    }
    @else {
      <input
        pInputText
        [id]="id"
        [type]="type"
        [ngModel]="value"
        [placeholder]="placeholder"
        [disabled]="disabled"
        (input)="onValueChange($event)"
        (blur)="onBlur()"
        class="w-full px-3 py-2 text-sm border border-[#D4D4D8] !rounded-xl focus:ring-2 transition-all duration-200 placeholder-gray-400 dark:placeholder-white !dark:bg-[#52525B]  "
      />
    }
  </div>
